import { render } from "./FileUploadQuestion.vue?vue&type=template&id=6ed45686&scoped=true"
import script from "./FileUploadQuestion.vue?vue&type=script&lang=js"
export * from "./FileUploadQuestion.vue?vue&type=script&lang=js"

import "./FileUploadQuestion.vue?vue&type=style&index=0&id=6ed45686&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ed45686"]])

export default __exports__